<div
  [className]="
    'InfoFormBox d-flex flex-row align-items-start justify-content-start InfoFormBox-' + status()
  ">
  @if (status() !== 'success' && showIcon()) {
    <mat-icon inline>info_outline</mat-icon>
  }
  <ng-content />
</div>
